import { render } from "./ElectricForm.vue?vue&type=template&id=aba2d136"
import script from "./ElectricForm.vue?vue&type=script&lang=js"
export * from "./ElectricForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__